import React, { useState } from 'react';
import ContentPage from '../contentPage/contentPage';
import PageWrapper from 'src/containers/pageWrapper/pageWrapper';

import styles from './contact.module.scss';

import googleIcon from './google_play_ico.svg';
import appstoreIcon from './appstore_ico.svg';
import instaIcon from './insta_ico.svg';
import fbIcon from './fb_ico.svg';
import { useSelector } from 'react-redux';
import { GlobalState } from 'src/logic/reducers';
import HalfImage from '../halfImage/halfImage';


const Contact = () => {
  const menuFile = useSelector((gs: GlobalState) => gs.settings.MENU_FILE);
  return (
    <ContentPage>
      <PageWrapper className={styles.contact}>
        <HalfImage image="/images/contact/kontakt-pieczec.png">
          <h1 className='h1'>Kontakt</h1>
          {menuFile && <h3>W tym miejscu znajdziesz nasze menu obiadowe na ten tydzień: <a href={menuFile} download="menu.pdf">pobierz</a></h3>}
          <p>Nasze dania przygotowujemy z sercem i sensem! Jeśli masz do nas jakieś pytania
  lub uwagi - zachęcamy do kontaktu.</p>
        <section>
                <h2>Głodny? Skontaktuj się z nami!</h2>
                <p>w sprawie zamówień internetowych:</p>
                <a href='mailto:on-line@pobudka.pl'>on-line@pobudka.pl</a>
                <p>w sprawie sprzedaży w biurach:</p>
                <a href='mailto:kontakt@pobudka.pl'>kontakt@pobudka.pl</a>
                <p>infolinia:</p>
                <a href='tel:+48222438300'>+48 222 438 300</a>
      </section>

        </HalfImage>

          <section>

          <h2>Godziny pracy Biura Obsługi Klienta:</h2>
          <p>poniedziałek - piątek: 08:00 - 15:00</p>
          </section>

                  <section className={styles.socialSection}>
          <h2>Znajdziesz nas także:</h2>
          <div className={styles.socialLinks}>
              <a href={'https://www.facebook.com/Pobudka.Catering'} rel='noopener noreferrer' target='_blank' className={styles.socialLink}>
                <img src='/images/contact/facebook.png' alt={'Polub nas na Facebooku'} /> Facebook
              </a>
              <a href={'https://www.instagram.com/pobudka_catering/'} rel='noopener noreferrer' target='_blank' className={styles.socialLink}>
                <img src='/images/contact/instagram.png' alt={'Śledź nas na Instagramie'} /> Instagram
              </a>
              <a href={'https://www.linkedin.com/company/pobudka/'} rel='noopener noreferrer' target='_blank' className={styles.socialLink}>
                <img src='/images/contact/linkedin.png' alt={'Śledź nas na LinkedInie'} /> LinkedIn
              </a>
              <a href={'https://www.tiktok.com/@catering_pobudka'} rel='noopener noreferrer' target='_blank' className={styles.socialLink}>
                <img src='/images/contact/tiktok.png' alt={'Śledź nas na TikToku'} /> TikTok
              </a>
            </div>
          </section>

         <section className={styles.socialSection}>
            <h2>Pobierz naszą aplikację mobilną:</h2>
            <div className={styles.appLinks}>
              <a
                href={'https://play.google.com/store/apps/details?id=pl.waw.pobudka.twa'}
                rel='noopener noreferrer'
                target='_blank'
              >
                <img src={'/images/contact/google-icon.png'} alt={'Pobierz aplikacje z Google Play'} height={60} />
              </a>
              <a href={'https://apps.apple.com/pl/app/pobudka/id1539031354'} rel='noopener noreferrer' target='_blank'>
                <img src={'/images/contact/app-store-icon.png'} alt={'Pobierz aplikacje z Appstore'} height={60} />
              </a>
            </div>
          </section>
      </PageWrapper>
    </ContentPage>
  );
};

export default Contact;
